import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { CtaBand } from '../components/CtaBand';
import { opportunities } from '../data/opportunities';
export function Opportunities() {
  const [sector, setSector] = useState('All sectors');
  const sectors = useMemo(() => ['All sectors', ...Array.from(new Set(opportunities.map(o => o.sector)))], []);
  const visible = sector === 'All sectors' ? opportunities : opportunities.filter(o => o.sector === sector);
  return <>
      <PageHero breadcrumb="Leadership Opportunities" title="Current leadership opportunities." lead="A selection of mandates we can share publicly. Client names remain confidential until later stages of the process." data-id="element-436" data-mp="swztugho7eez" />
      <section className="bg-ivory" data-id="element-437" data-mp="2n84wpikxnmt9">
        <div className="mx-auto max-w-site px-6 py-20 lg:px-10 lg:py-28" data-id="element-438" data-mp="2s9c4hhn2slzx">
          <div className="flex flex-wrap gap-2" role="group" aria-label="Filter by sector" data-id="element-439" data-mp="32eeh0rhr4f5t">
            {sectors.map(s => <button key={s} type="button" onClick={() => setSector(s)} aria-pressed={sector === s} className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors duration-150 ease-out ${sector === s ? 'bg-midnight-900 text-champagne-50' : 'bg-white text-midnight-900/75 ring-1 ring-midnight-900/15 hover:ring-midnight-900/40'}`} data-id="element-440" data-mp="2ybzy67e31fej">
                {s}
              </button>)}
          </div>

          <ul className="mt-12 border-b border-midnight-900/15" data-id="element-441" data-mp="2tblpcn4nq1fg">
            {visible.map(role => <li key={role.id} className="grid gap-4 border-t border-midnight-900/15 py-8 lg:grid-cols-12 lg:items-center lg:gap-8" data-id="element-442" data-mp="8nqwlrqyodsf">
                <div className="lg:col-span-4" data-id="element-443" data-mp="3pflzesudz95">
                  <h2 className="font-serif text-3xl text-midnight-900" data-id="element-444" data-mp="3qqpddidl4zq">{role.title}</h2>
                  <p className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-midnight-900/60" data-id="element-445" data-mp="bp2hzo7832st">
                    <span data-id="element-446" data-mp="fss1w0cycw7i">{role.sector}</span>
                    <span aria-hidden="true" data-id="element-447" data-mp="kpquufkvqx44">·</span>
                    <span className="inline-flex items-center gap-1" data-id="element-448" data-mp="ko7d0kjkse08">
                      <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-449" data-mp="polbbavdk9l2" />
                      {role.location}
                    </span>
                  </p>
                </div>
                <p className="text-[15px] leading-relaxed text-midnight-900/75 lg:col-span-5" data-id="element-450" data-mp="3t6vb8j5jcw70">{role.summary}</p>
                <div className="lg:col-span-3 lg:text-right" data-id="element-451" data-mp="1xy1ul5t9bwe">
                  <Link to={`/contact?type=candidate&role=${encodeURIComponent(role.title + ' — ' + role.sector)}`} className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-midnight-900 underline decoration-champagne-500 underline-offset-[6px]" data-id="element-452" data-mp="6qr85dgxgsal">
                    Express interest
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-453" data-mp="32tgt8ozode0c" />
                  </Link>
                </div>
              </li>)}
          </ul>

          <p className="mt-10 max-w-2xl text-[15px] leading-relaxed text-midnight-900/65" data-id="element-454" data-mp="2sw2j174chlgh">
            Don’t see the right role? Most of our mandates are confidential.{' '}
            <Link to="/contact?type=candidate" className="font-medium text-midnight-900 underline decoration-champagne-500 underline-offset-4" data-id="element-455" data-mp="2jy0j6uwckyus">
              Introduce yourself
            </Link>{' '}
            and we’ll be in touch when a suitable opportunity arises.
          </p>
        </div>
      </section>
      <CtaBand data-id="element-456" data-mp="259drrutg4gn7" />
    </>;
}